import React from "react";
export const Photo1Shape = ({ image }) => {
  return (
    <svg 
      width="100%" 
      height="100%" 
      viewBox="0 0 237 237" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block' }}
    >
      <defs>
        <clipPath id="photo1Clip">
          <circle cx="118.23" cy="118.23" r="118.23" />
        </clipPath>
      </defs>
      
      <circle 
        cx="118.23" 
        cy="118.23" 
        r="118.23" 
        fill="#C4C4C4"
      />
      
      <image
        href={image}
        x="0"
        y="0"
        width="237"
        height="237"
        clipPath="url(#photo1Clip)"
        preserveAspectRatio="xMidYMid slice"
      />
    </svg>
  );
};
export default Photo1Shape;